<template>
  <confirmation-dialog :action="handleRemove" confirm-text="Удалить" confirm-btn-variant="accent" cancel-text="Отмена">
    <template #activator>
      <slot />
    </template>

    <div class="h3">Удаление категории номера</div>
    <div class="text-secondary mt-6">
      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam vitae efficitur lectus. Suspendisse tempus aliquam
      massa. Fusce vitae feugiat metus.
    </div>
  </confirmation-dialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from '@/core/components/modals/ConfirmationDialog.vue';
import { useSnackbar } from '@/core/composables/useSnackbar';
import { useRoomCategoriesStore } from '@/parts/room-categories/store/roomCategories';

const props = defineProps<{
  roomCategoryId?: string;
}>();

const emit = defineEmits<{
  (event: 'remove-success'): void;
}>();

const { removeRoomCategory } = useRoomCategoriesStore();
const { showSnackbar } = useSnackbar();

const handleRemove = async () => {
  if (!props.roomCategoryId) return;

  const result = await removeRoomCategory(props.roomCategoryId);

  if (!result?.errors) {
    showSnackbar({
      type: 'success',
      title: 'Категория номеров удалена',
    });
    emit('remove-success');
  }
};
</script>
